import React from 'react'
import ThisProject from '../ThisProject';
import { ImageMedia } from '../../components/imports';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent pt-24'>
          <ImageMedia
            key={"yellow"}
            src={require('./assets/FF_010_R014.jpg')}
            className="md:landscape:scale-[120%] object-contain max-h-[110vh] overflow-y-hidden full"
          />

          <div className='grid grid-cols-3 items-center paddingY'>
            <ImageMedia
              key={"FF_1"}
              src={require('./assets/FF_021_R001.jpg')}
              className=""
            />
            <ImageMedia
              key={"FF_2"}
              src={require('./assets/hero.jpg')}
              className="md:landscape:scale-[120%]"
            />
            <ImageMedia
              key={"FF_3"}
              src={require('./assets/FF_021_R002.jpg')}
              className=""
            />
          </div>
        </div>
      )}
    </ThisProject>
  )
}

export default Content